import { memo, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { closeModal, openModal } from "../../store/actions/modalAction";
import HearNUListUI from "./HearNUListUI";
import HearNUCreateController from "../customhearnu/HearNUCreate/HearNUCreateController";
import { IconButton, Tooltip, Typography, Chip, Box } from "@mui/material";
import moment from "moment";
import { findObjectKeyByValue } from "../../utils/helper";
import {
  GENDER,
  ORDER_PROCESS_STATUS,
  SNACK_BAR_VARIETNS,
  USER_ROLES,
} from "../../utils/constants";
import MessageDilog from "../../components/MessageDilog";
import { Edit, Visibility } from "@mui/icons-material";
import DoneIcon from "@mui/icons-material/Done";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PatientInformationController from "./HearNUView/PatientInformationController";
import { callApiAction } from "../../store/actions/commonAction";
import {
  fetchOrderCountApi,
  fetchPatientApi,
  updateOrderApi,
} from "../../apis/patient.api";
import AssignOrderController from "./AssignOrderController";
import { callSnackBar } from "../../store/actions/snackbarAction";
import OrderShipController from "./OrderShip/OrderShipController";
import OrderViewController from "./OrderShip/OrderViewController";
import OrderCancelController from "./OrderCancel/OrderCancelController";

const ActionComponent = memo(({ params, setParams, callBack }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state);

  const onView = () => {
    dispatch(
      openModal(
        <PatientInformationController id={params?._id} />,
        "xl",
        false,
        "PatientInformation"
      )
    );
  };

  const onCancel = () => {
    dispatch(
      openModal(
        <OrderCancelController
          params={params}
          status={params?.order_status}
          callBack={callBack}
        />,
        "sm",
        false,
        "orderCancel"
      )
    );
  };

  const onOrderFun = () => {
    dispatch(
      openModal(
        <OrderShipController
          params={params}
          status={params?.order_status}
          callBack={callBack}
        />,
        "sm",
        false,
        "orderShip"
      )
    );
  };

  const onEdit = () => {
    dispatch(
      openModal(
        <HearNUCreateController id={params?._id} callBack={() => callBack()} />,
        "lg",
        true,
        "HearNUUpdate"
      )
    );
  };

  const onOrderView = () => {
    dispatch(
      openModal(
        <OrderViewController id={params?._id} params={params} />,
        "md",
        false,
        "OrderInformation"
      )
    );
  };

  const onShipping = async (e) => {
    e.preventDefault();
    setLoading(true)
    if (params?.order_status === ORDER_PROCESS_STATUS.ORDER_SHIPPED) {
      dispatch(
        callApiAction(
          async () =>
            await updateOrderApi({
              id: params?.order_ID,
              status: params?.order_status,
            }),
          async (response) => {
            const data = {
              order_status: response?.status,
              isAssigned: response?.isAssigned,
            };
            dispatch(
              callSnackBar(
                "Order Fulfilled Successfully",
                SNACK_BAR_VARIETNS.success
              )
            );
            await callBack();
            dispatch(closeModal());
            setLoading(false);
          },
          async (err) => {
            dispatch(callSnackBar("Error", SNACK_BAR_VARIETNS.error));
            dispatch(closeModal());
            setLoading(false);
          }
        )
      );
    } else {
      dispatch(
        callApiAction(
          async () =>
            await updateOrderApi({
              id: params?.order_ID,
              status: params?.order_status,
            }),
          async (response) => {
            const data = {
              order_status: response?.status,
              isAssigned: response?.isAssigned,
            };
            dispatch(
              callSnackBar(
                "Order Shipped Successfully",
                SNACK_BAR_VARIETNS.success
              )
            );
            await callBack();
            dispatch(closeModal());
            setLoading(false);
          },
          async (err) => {
            dispatch(callSnackBar("Error", SNACK_BAR_VARIETNS.error));
            dispatch(closeModal());
            setLoading(false);
          }
        )
      );
    }
  };

  const onAssign = (e) => {
    e.preventDefault();
    if (
      params?.isAssigned &&
      params?.order_status === ORDER_PROCESS_STATUS.ORDER_ACCEPTED
    ) {
      dispatch(
        openModal(
          <MessageDilog
            key={JSON.stringify(loading)}
            loading={loading}
            title="Order Shipping"
            message="Are you sure You want to Ship this order?"
            onSubmit={onShipping}
          />,
          "sm",
          false
        )
      );
    } else if (
      params?.isAssigned ||
      user?.data?.role === USER_ROLES?.DISTRIBUTOR ||
      params?.order_status === ORDER_PROCESS_STATUS.ORDER_SHIPPED
    ) {
      dispatch(
        openModal(
          <MessageDilog
            loading={loading}
            key={loading}
            title="Order Fulfillment"
            message="Have you received the product?"
            onSubmit={onShipping}
          />,
          "sm",
          false
        )
      );
    } else {
      dispatch(
        openModal(
          <AssignOrderController
            id={params._id}
            status={params.order_status}
            order_ID={params.order_ID}
            callBack={(updatedData) => {
              callBack();
              setParams({ ...params, ...updatedData });
            }}
          />,
          "sm",
          false,
          "AssignInformation"
        )
      );
    }
  };

  return (
    <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>
      {[
        USER_ROLES?.SUPER_ADMIN,
        USER_ROLES?.ADMIN,
        USER_ROLES?.PRODUCT_MANAGER,
        USER_ROLES?.DISTRIBUTOR,
      ].includes(user?.data?.role) && (
        <Tooltip title="View">
          <IconButton size="inherit" onClick={() => onOrderView()}>
            <Visibility fontSize="inherit" color="info" />
          </IconButton>
        </Tooltip>
      )}

      {[USER_ROLES?.ASSEMBLY].includes(user?.data?.role) && (
        <Tooltip title="View">
          <IconButton size="inherit" onClick={() => onView()}>
            <Visibility fontSize="inherit" color="info" />
          </IconButton>
        </Tooltip>
      )}

      {[USER_ROLES?.DISTRIBUTOR].includes(user?.data?.role) &&
        params?.order_status !== ORDER_PROCESS_STATUS?.FULFILLED && 
        params?.order_status !== ORDER_PROCESS_STATUS?.ORDER_SHIPPED && 
        params?.order_status !== ORDER_PROCESS_STATUS?.ORDER_REJECTED &&(
          <Tooltip title="Update">
            <span>
              <IconButton size="inherit" onClick={onEdit}>
                <Edit fontSize="inherit" color="info" />
              </IconButton>
            </span>
          </Tooltip>
        )}

      {[USER_ROLES?.PRODUCT_MANAGER].includes(user?.data?.role) && 
      (params?.order_status !== ORDER_PROCESS_STATUS?.ORDER_REJECTED) &&
        (!params?.isAssigned ? (
          <Tooltip title="Assign">
            <IconButton size="inherit" onClick={onAssign}>
              <AssignmentIndIcon color="info" fontSize="inherit" />
            </IconButton>
          </Tooltip>
        ) : (
          params?.order_status === ORDER_PROCESS_STATUS?.ORDER_ACCEPTED && (
            <Tooltip title="Shipping Order">
              <IconButton size="inherit" onClick={onOrderFun}>
                <LocalShippingIcon
                  color="info"
                  fontSize="inherit"
                  sx={{ fontSize: "20px", fontWeight: "bold", mt: "2px" }}
                />
              </IconButton>
            </Tooltip>
          )
        ))}

      {[USER_ROLES?.DISTRIBUTOR].includes(user?.data?.role) &&
        params?.order_status === ORDER_PROCESS_STATUS?.ORDER_SHIPPED && (
          <Tooltip title="Fulfill Order">
            <IconButton size="inherit" onClick={onAssign}>
              <DoneIcon
                color="info"
                fontSize="inherit"
                sx={{ fontSize: "25px", fontWeight: "bold" }}
              />
            </IconButton>
          </Tooltip>
        )}

        {[USER_ROLES.DISTRIBUTOR].includes(user?.data?.role) &&
          moment().isBefore(moment(params?.assigned_date).add(3, "days")) &&
          params?.order_status !== ORDER_PROCESS_STATUS.ORDER_REJECTED &&
          params?.order_status !== ORDER_PROCESS_STATUS.ORDER_SHIPPED &&
          params?.order_status !== ORDER_PROCESS_STATUS.FULFILLED && (
            <Tooltip title="Cancel Order">
              <IconButton size="inherit" onClick={() => onCancel()}>
                <CloseIcon fontSize="inherit" color="error" />
              </IconButton>
            </Tooltip>
        )}
    </Box>
  );
});

const HearNUController = () => {
  const { user, patientDetail } = useSelector((state) => state);
  const [loading, setLoading] = useState(false);
  const [countLoading, setCountLoading] = useState(false);
  const [count, setCount] = useState();
  const [list, setList] = useState({});
  const dispatch = useDispatch();
  const params = useParams();
  const [countStatus, setCountStatus] = useState();
  const colorMap = {
    3: "orange",
    2: "orange",
    1: "orange",
    0: "red",
  };

  const STATUS_COLORS = {
    [ORDER_PROCESS_STATUS?.ORDER_RECEIVED]: {
      backgroundColor: "#FF9800",
      color: "#fff",
    },
    [ORDER_PROCESS_STATUS?.ORDER_REJECTED]: {
      backgroundColor: "#FF0000",
      color: "#fff",
    },
    [ORDER_PROCESS_STATUS?.ORDER_ACCEPTED]: {
      backgroundColor: "#03A9F4",
      color: "#fff",
    },
    [ORDER_PROCESS_STATUS?.ORDER_SHIPPED]: {
      backgroundColor: "#0D47A1",
      color: "#fff",
    },
    [ORDER_PROCESS_STATUS?.FULFILLED]: {
      backgroundColor: "#4CAF54",
      color: "#fff",
    },
  };

  const [filters, setFilters] = useState({
    usercode: params.usercode,
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ["name", "order_id"],
    sort: "createdAt",
    sortDirection: -1,
  });

  const onVeiw = (params) => {
    dispatch(
      openModal(
        <PatientInformationController id={params?._id} />,
        "xl",
        false,
        "PatientInformation"
      )
    );
  };

  const onCreateBtnClick = () => {
    dispatch(
      openModal(
        <HearNUCreateController
          callBack={() => {
            fetchOrderCount();
            fetchPatientList(); // Refresh table after adding a patient
          }}
        />,
        "lg",
        true,
        "HearNUCreate"
      )
    );
  };

  const fetchPatientList = () => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await fetchPatientApi({ ...filters, status: countStatus }),
        async (response) => {
          setList(response);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  };

  const fetchOrderCount = () => {
    setCountLoading(true);
    dispatch(
      callApiAction(
        async () => await fetchOrderCountApi({ ...filters }),
        (response) => {
          setCount(response);
          setCountLoading(false);
        },
        (err) => {
          setCountLoading(false);
        }
      )
    );
  };

  useEffect(() => {
    fetchOrderCount();
  }, [filters.startDate, filters.endDate]);

  useEffect(() => {
    if (count?.length > 0) {
      if (!countStatus) {
        if (countStatus === ORDER_PROCESS_STATUS?.ALL) {
          fetchPatientList();
        } else {
          setCountStatus(count[0]?.status);
        }
      } else {
        fetchPatientList();
      }
    }
  }, [count]);

  useEffect(() => {
    fetchPatientList();
  }, [filters, countStatus]);

  const columns = useMemo(() => {
    const cols = [
      {
        id: 1,
        minWidth: "50px",
        fieldName: "order_id",
        label: "Order ID",
        align: "left",
        sort: true,
        renderValue: (params) => (
          <Typography sx={{ color: "black" }}>{params?.order_id}</Typography>
        ),
      },
      {
        id: 2,
        fieldName: "createdAt",
        label: "Created Date",
        align: "left",
        sort: true,
        renderValue: (params) => (
          <Typography sx={{ color: "black" }}>
            {moment(params?.createdAt).format("DD-MM-YYYY")}
          </Typography>
        ),
      },
      {
        id: 3,
        fieldName: "name",
        label: "Patient Name",
        align: "left",
        sort: false,
        renderValue: (params) => (
          <Typography
            sx={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => onVeiw(params)}
          >
            {params?.name}
          </Typography>
        ),
      },
      {
        id: 4,
        fieldName: "gender",
        label: "Gender",
        align: "left",
        renderValue: (params) => (
          <Typography sx={{ color: "black" }}>
            {findObjectKeyByValue(parseInt(params?.gender), GENDER)}
          </Typography>
        ),
      },
      {
        id: 6,
        fieldName: "",
        label: "Action",
        align: "right",
        renderValue: (params, setParams) => (
          <ActionComponent
            loading={loading}
            setLoading={setLoading}
            key={params?._id}
            params={params}
            setParams={setParams}
            callBack={() => {
              fetchOrderCount();
              fetchPatientList();
            }}
          />
        ),
      },
    ];

    if ([USER_ROLES?.PRODUCT_MANAGER].includes(user?.data?.role)) {
      cols.splice(4, 0, {
        id: 5,
        fieldName: "distributor_name",
        label: "Distributor Name",
        align: "left",
        renderValue: (params) => (
          <Typography sx={{ color: "black" }}>
            {params?.distributor_name}
          </Typography>
        ),
      });
    }

    if (
      [
        USER_ROLES?.PRODUCT_MANAGER,
        USER_ROLES?.DISTRIBUTOR,
        USER_ROLES?.SUPER_ADMIN,
        USER_ROLES?.ADMIN,
      ].includes(user?.data?.role)
    ) {
      let spliceIndex = 4;
      if (user?.data?.role === USER_ROLES?.PRODUCT_MANAGER) {
        spliceIndex = 5;
      }
      cols.splice(spliceIndex, 0, {
        id: 5,
        minWidth: "50px",
        fieldName: "order_status",
        label: "Order Status",
        align: "left",
        renderValue: (params) => {
          const orderStatus = parseInt(params?.order_status);
          const chipStyles = STATUS_COLORS[orderStatus] || {
            backgroundColor: "#B0BEC5",
            color: "#000",
          };
          return (
            <Chip
              label={
                user?.data?.role === USER_ROLES?.DISTRIBUTOR &&
                orderStatus === 1
                  ? "Order Placed"
                  : findObjectKeyByValue(orderStatus, ORDER_PROCESS_STATUS)
              }
              sx={{
                ...chipStyles,
                minWidth: "130px",
                fontWeight: "bold",
                fontSize: "15px",
                textAlign: "center",
              }}
            />
          );
        },
      });
    }

    if ([USER_ROLES?.ASSEMBLY].includes(user?.data?.role)) {
      cols.splice(1, 0, {
        id: 7,
        minWidth: "50px",
        fieldName: "assigned_date",
        label: "Assigned Date",
        align: "left",
        sort: true,
        renderValue: (params) => (
          <Typography sx={{ color: "black" }}>
            {moment(params?.assigned_date).format("DD-MM-YYYY")}
          </Typography>
        ),
      });

      cols.splice(2, 0, {
        id: 8,
        minWidth: "50px",
        fieldName: "delivery_date",
        label: "Delivery Date",
        align: "left",
        sort: false,
        renderValue: (params) => {
          const deliveryDate = moment(params?.assigned_date).add(10, "days");
          return (
            <Typography sx={{ color: "black" }}>
              {deliveryDate.format("DD-MM-YYYY")}
            </Typography>
          );
        },
      });
      cols.splice(3, 1);
      cols.splice(4, 1);
    }

    if ([3].includes(user?.data?.role)) {
      cols.splice(6, 0, {
        id: 9,
        minWidth: "50px",
        fieldName: "time_duration",
        label: "Time Duration",
        align: "left",
        sort: false,
        renderValue: (params) => {
          if (params?.order_status === ORDER_PROCESS_STATUS.FULFILLED) {
            return <Typography sx={{ color: "black" }}>{""}</Typography>;
          }
          if (params?.isAssigned) {
            const assignedDate = moment(params?.assigned_date).startOf("day");
            const deliveryDate = assignedDate.clone().add(10, "days"); // 10 days total including assigned date
            const today = moment().startOf("day");

            let remainingDays = deliveryDate.diff(today, "days");

            const safeRemainingDays = Math.max(0, remainingDays); // prevent negative
            const colorMap = {
              3: "orange",
              2: "orange",
              1: "orange",
              0: "red",
            };
            const chipColor = colorMap[safeRemainingDays] || "transparent";

            return safeRemainingDays > 3 ? (
              <Typography sx={{ color: "black", fontWeight: "bold" }}>
                {`${safeRemainingDays} Days`}
              </Typography>
            ) : (
              <Chip
                label={
                  safeRemainingDays > 0 ? `${safeRemainingDays} Days` : "0 Days"
                }
                sx={{
                  backgroundColor: chipColor,
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              />
            );
          }
          return <Typography sx={{ color: "black" }}>{""}</Typography>;
        },
      });
    } else if ([USER_ROLES?.ASSEMBLY].includes(user?.data?.role)) {
      cols.splice(4, 0, {
        id: 9,
        minWidth: "50px",
        fieldName: "time_duration",
        label: "Time Duration",
        align: "left",
        sort: false,
        renderValue: (params) => {
          const assignedDate = moment(params?.assigned_date).startOf("day");
          const deliveryDate = assignedDate.clone().add(10, "days"); // 10 days total including assigned date
          const today = moment().startOf("day");

          let remainingDays = deliveryDate.diff(today, "days");

          const safeRemainingDays = Math.max(0, remainingDays); // prevent negative
          const colorMap = {
            3: "orange",
            2: "orange",
            1: "orange",
            0: "red",
          };
          const chipColor = colorMap[safeRemainingDays] || "transparent";

          return safeRemainingDays > 3 ? (
            <Typography sx={{ color: "black", fontWeight: "bold" }}>
              {`${safeRemainingDays} Days`}
            </Typography>
          ) : (
            <Chip
              label={
                safeRemainingDays > 0 ? `${safeRemainingDays} Days` : "0 Days"
              }
              sx={{
                backgroundColor: chipColor,
                color: "white",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            />
          );
        },
      });
    }
    return cols;
  }, [user?.data?.role, dispatch]);

  return (
    <>
      <HearNUListUI
        onCreateBtnClick={onCreateBtnClick}
        filters={filters}
        setFilters={setFilters}
        columns={columns}
        loading={loading}
        list={list}
        countLoading={countLoading}
        count={count}
        setCountStatus={setCountStatus}
        countStatus={countStatus}
      />
      {/* <PopUpModal /> */}
    </>
  );
};

export default memo(HearNUController);
